/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
export const privatePhone = function(val, retain = 4) {
  if (!Number(val) || String(val).length !== 11 || retain == 0) return val;
  let mobile = String(val);
  let digit = 11 - 3 - retain;
  let reg = new RegExp(`^(\\d{3})\\d{${digit}}(\\d{${retain}})$`);
  return mobile.replace(reg, `$1${"*".repeat(digit)}$2`);
};

// 风险提示stpe阶段title
const riskTitle = [
  {
    statusName: "受让登记风险提示",
    status: 0
  },
  {
    statusName: "选择受让登记方式",
    status: 1
  },
  {
    statusName: "",
    status: 2
  },
  {
    statusName: "重新选择代理机构",
    status: 3
  }
];
export const riskTitleFilter = status => {
  if (!status && status !== 0) {
    return "----";
  }
  let riskTitleLabel = "";
  riskTitle.map(item => {
    if (item.status === status) {
      riskTitleLabel = item.statusName;
    }
  });
  return riskTitleLabel;
};


const businessAuthTypeDesc = [
  {
    statusName: "高校",
    status: 1
  },
  {
    statusName: "企业",
    status: 2
  },
  {
    statusName: "自然人",
    status: 3
  }
];
export const businessAuthTypeFilter = status => {
  if (!status && status !== 0) {
    return "----";
  }
  let businessAuthTypeName = "";
  businessAuthTypeDesc.map(item => {
    if (item.status === status) {
      businessAuthTypeName = item.statusName;
    }
  });
  return businessAuthTypeName;
};

// 成果受让状态
// 状态[0待支付;1支付成功(未登记);2已登记(待处理);3支付失败;4已接受;5已拒绝;6待选择(已提交资料);7已选中;8未选中]
const transferStatusDesc = [
  {
    statusName: "待支付",
    status: 0
  },
  {
    statusName: "未登记/支付成功",
    status: 1
  },
  {
    statusName: "已登记/待处理",
    status: 2
  },
  {
    statusName: "支付失败",
    status: 3
  },
  {
    statusName: "已接受",
    status: 4
  },
  {
    statusName: "已拒绝",
    status: 5
  },
  {
    statusName: "待选择",
    status: 6
  },
  {
    statusName: "已选中",
    status: 7
  },
  {
    statusName: "未选中",
    status: 8
  }
];
export const transferStatusFilter = status => {
  if (!status && status !== 0) {
    return "----";
  }
  let transferStatusName = "";
  transferStatusDesc.map(item => {
    if (item.status === status) {
      transferStatusName = item.statusName;
    }
  });
  return transferStatusName;
};

// 竞价交易状态
// 状态[-1或不传返回全部;0待支付;1支付成功(竞拍中);2支付失败;3已中标;4未中标;5已流标]
const competitiveStatusDesc = [
  {
    statusName: "未支付",
    status: 0
  },
  {
    statusName: "竞拍中",
    status: 1
  },
  {
    statusName: "支付失败",
    status: 2
  },
  {
    statusName: "已中标",
    status: 3
  },
  {
    statusName: "未中标",
    status: 4
  },
  {
    statusName: "已流标",
    status: 5
  }
];
export const competitiveStatusFilter = status => {
  if (!status && status !== 0) {
    return "----";
  }
  let competitiveStatusName = "";
  competitiveStatusDesc.map(item => {
    if (item.status === status) {
      competitiveStatusName = item.statusName;
    }
  });
  return competitiveStatusName;
};

// 我关注的竞价交易状态
// 状态[-1或不传返回全部;0待支付;1支付成功(竞拍中);2支付失败;3已中标;4未中标;5已流标]
const myCompetitiveStatusDesc = [
  {
    statusName: "未上架",
    status: 0
  },
  {
    statusName: "即将开始",
    status: 1
  },
  {
    statusName: "竞拍中",
    status: 2
  },
  {
    statusName: "已结束",
    status: 3
  },
  {
    statusName: "已评标",
    status: 4
  },
  {
    statusName: "已流标",
    status: 5
  }
];
export const myCompetitiveStatusFilter = status => {
  if (!status && status !== 0) {
    return "----";
  }
  let myCompetitiveStatusName = "";
  myCompetitiveStatusDesc.map(item => {
    if (item.status === status) {
      myCompetitiveStatusName = item.statusName;
    }
  });
  return myCompetitiveStatusName;
};

// 认证状态过滤
const topicTypeDesc = [
  
  {
    statusName: "未认证",
    status: 0
  },{
    statusName: "认证中",
    status: 1
  },
  {
    statusName: "已认证",
    status: 2
  },
  {
    statusName: "认证失败",
    status: 3
  },
];
export const isBusinessAuthFilter = status => {
  if (!status && status !== 0) {
    return "----";
  }
  let topicTypeName = "";
  topicTypeDesc.map(item => {
    if (item.status === status) {
      topicTypeName = item.statusName;
    }
  });
  return topicTypeName;
};
/**
 * 提取数组中的字段组成字符串
 */
export const ArrtoString = (arr, key) => {
  if (!arr || arr.length === 0) {
    return "暂无处方药品";
  }
  let returnArr = [];
  arr.map(item => {
    returnArr.push(item[key]);
  });
  return returnArr.toString();
};

export const startToEnd = (start, end) => {
  if (!start) {
    return "---- ---- ----";
  }
  return start + " - " + end.substring(10);
};

// 金额分位及浮点转化
export const moneyFormat = (num,symbo='') => {
  if (!num) {
    if (num === 0) {
      return symbo+"0.00";
    } else {
      return symbo+"--";
    }
  }
  // 接受数字变双浮点
  let numToFloat = num.toFixed(2);
  // 分割整数和浮点数
  let num0 = numToFloat.split(".")[0];
  let num1 = numToFloat.split(".")[1];
  num0 = parseInt(num0).toLocaleString();
  return symbo + num0 + "." + num1;
};

// 药房距离转化 大于1000m => 1km
export const metre2kilometre = metre => {
  console.log(metre);
  let newValue = "";
  if (metre >= 1000) {
    newValue = (metre / 1000).toFixed() + "公里";
  } else {
    newValue = metre.toFixed() + "米";
  }
  return newValue;
};

// // 时间戳转时间格式
// export const timestamp2Date = (timestamp) => {
//   return timestamp
// }

// 点赞数量转化 大于1000 =>1k+  大于1万 => 10k+
export const counts2ShortCounts = counts => {
  if (!counts) {
    return "0";
  } else {
    let shortCounts = "0";
    if (counts <= 999) {
      shortCounts = counts;
    } else {
      shortCounts = "999+";
    }

    return shortCounts;
  }
};

// 论坛投票题型
export const questionTypeName = type => {
  if (!type) {
    return "----";
  } else {
    let typeName = "";
    switch (type) {
      case 1:
        typeName = "单选";
        break;
      case 2:
        typeName = "多选";
        break;
      case 3:
        typeName = "填空";
        break;
      default:
        break;
    }
    return typeName;
  }
};

// 日期格式转化
export const dateChange = date => {
  if (date) {
    let createTime = date.split(/年|月|日/);
    return createTime[0] + "/" + createTime[1] + "/" + createTime[2];
  } else {
    return "----";
  }
};
export const commentDate= date => {
  if(date){
    let now = new Date()
    let nowYear = now.getFullYear()
    // 判断日期是否包含当前年份,包含则删除
    if(date.search(nowYear+'')!==-1){
      return date.substring(5)
    }else {
      return date
    }
  }
}
const applyStatusName = {
  0: '待申报',
  1: '待审核', // 产品经理
  2: '取消申报',
  3: '审核中',
  4: '审核中', // 财务
  5: '不通过',
  6: '待处理(确认收款账户)',
  7: '收款账户已确认', // 服务商
  8: '已拨付(上传凭证)',
  9: '已拨付(凭证已上传)',
  10: '兑现结束'
}
export function applyStatusFilter(invoiceStatus) {
  return applyStatusName[invoiceStatus]
}